var EventEmitter = require('eventemitter3');

exports.emitter = new EventEmitter();



// WEBPACK FOOTER //
// ../~/dna-core/components/eventemitter/index.js